import { render } from "./ServiceContent.vue?vue&type=template&id=5422c86a&scoped=true"
import script from "./ServiceContent.vue?vue&type=script&lang=js"
export * from "./ServiceContent.vue?vue&type=script&lang=js"

import "./ServiceContent.vue?vue&type=style&index=0&id=5422c86a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5422c86a"

export default script